import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const CardStyled = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  overflow: hidden;
  cursor: pointer;
`;

export const MainView = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 18px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 600px) {
    font-size: 16px !important;
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  color: var(--main-color);
  transform: ${({ isOpened }) =>
    isOpened ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.2s ease;
`;

export const TextWrapper = styled.div`
  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;
`;

export const InnerWrapper = styled.div`
  padding: 0 24px 24px;
`;
